<!--
 * @Description: tagsView 刷新时的跳板页面
 * @Author: sunxiaodong
 * @Date: 2020-04-23 14:45:51
 * @LastEditors: WuPuyi
 * @LastEditTime: 2021-04-15 11:25:22
 -->
<script>
export default {
  created() {
    console.log(this.$route);
    const { params, query } = this.$route;
    const { path } = params;
    console.log(path);
    this.$router.replace({ path: "/" + path, query });
  },
  render: function(h) {
    return h();
  }
};
</script>
